import { Typography, Row, Col, Form, Input, Card, Select } from "antd";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../../../components/custom/CustomButton";
import { useEffect, useState } from "react";

const { Text } = Typography;

// ── Status pill — shared with ViewBranchForm ──────────────────────────────────
const STATUS_CONFIG = {
  0: { label: "None",    color: "#6b7280", bg: "rgba(107,114,128,0.10)" },
  1: { label: "All",     color: "#15CCAE", bg: "rgba(21,204,174,0.10)" },
  2: { label: "Partial", color: "#f59e0b", bg: "rgba(245,158,11,0.10)" },
};

const StatusPill = ({ status }) => {
  const cfg = STATUS_CONFIG[status] ?? STATUS_CONFIG[0];
  return (
    <span
      style={{
        display: "inline-block",
        padding: "2px 10px",
        borderRadius: 20,
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: 0.5,
        backgroundColor: cfg.bg,
        color: cfg.color,
        border: `1px solid ${cfg.color}33`,
        marginLeft: 8,
        verticalAlign: "middle",
      }}
    >
      {cfg.label}
    </span>
  );
};

const EditbranchTypeForm = ({
  allowedPaymentTypeData,
  session,
  setIsLoading,
  cnt,
  apiConfig,
  BOM,
  selectedBranchTypeKey,
}) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [allowedStatus, setAllowedStatus] = useState(0);
  const totalOptions = allowedPaymentTypeData?.length || 0;

  useEffect(() => {
    getBranchTypeById(selectedBranchTypeKey.id);
  }, []);

  const onCancel = () => {
    navigate("/sya0300", { replace: false });
  };

  const handleToggleAll = () => {
    if (allowedStatus === 1) {
      form.setFieldValue("allowedPaymentTypes", []);
      setAllowedStatus(0);
    } else {
      form.setFieldValue(
        "allowedPaymentTypes",
        allowedPaymentTypeData.map((o) => o.value),
      );
      setAllowedStatus(1);
    }
  };

  const onValuesChange = (_, allValues) => {
    const selected = allValues.allowedPaymentTypes || [];
    if (selected.length === 0) {
      setAllowedStatus(0);
    } else if (selected.length === totalOptions) {
      setAllowedStatus(1);
    } else {
      setAllowedStatus(2);
    }
  };

  const getBranchTypeById = (id) => {
    const url = `${apiConfig.Officetype}/${id}?template=true`;
    const body = { session };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const STATUS_MAP = { None: 0, All: 1, Partial: 2 };
        setAllowedStatus(STATUS_MAP[res?.allowedPaymentTypes] ?? 0);

        form.setFieldsValue({
          name: res?.name || "",
          allowedPaymentTypes: (res?.configuredPaymentTypes || []).filter((item) => item.id != null).map((item) => item.id),
        });

        setIsLoading(false);
      }
    });
  };

  const handleSubmit = (values) => {
    const body = {
      name: values.name,
      paymentTypes: values.allowedPaymentTypes,
      allowedPaymentTypes: allowedStatus,
      method: "PUT",
      session,
      locale: "en",
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, `${apiConfig.Officetype}/${selectedBranchTypeKey.id}`, (err) => {
      setIsLoading(false);
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Branch Type Updated Successfully");
        navigate("/sya0300", { replace: false });
      }
    });
  };

  return (
    <Form
      form={form}
      layout="vertical"
      style={{ paddingTop: 20 }}
      onFinish={handleSubmit}
      onValuesChange={onValuesChange}
    >
      <Card
        style={{ boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)", borderRadius: 20 }}
        title="Edit Branch Type"
      >
        <Card
          style={{ marginBottom: "2%", boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)" }}
        >
          <Row gutter={24}>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                name="name"
                label={<Text strong>Name</Text>}
                rules={[{ required: true, message: "Required Field" }]}
              >
                <Input placeholder="Enter Branch Name" />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12}>
              <Form.Item
                name="allowedPaymentTypes"
                label={
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                    <span>
                      <Text strong>Allowed Payment Types</Text>
                      <StatusPill status={allowedStatus} />
                    </span>
                    <span
                      style={{ fontSize: 12, color: "#15CCAE", cursor: "pointer", fontWeight: 500, userSelect: "none", marginLeft: 12 }}
                      onClick={handleToggleAll}
                    >
                      {allowedStatus === 1 ? "Deselect All" : "Select All"}
                    </span>
                  </div>
                }
              >
                <Select
                  mode="multiple"
                  showSearch
                  placeholder="Select Options"
                  options={allowedPaymentTypeData}
                />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        <Form.Item>
          <Row>
            <CustomButton
              content="Submit"
              htmlType="submit"
              style={{
                width: "10%",
                marginLeft: "auto",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              }}
              backgroundColor="#15CCAE"
              colorText="black"
              hoverBackground="#4FECA0"
            />
            <CustomButton
              content="Cancel"
              style={{
                width: "10%",
                marginLeft: "1%",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              }}
              backgroundColor="#fff"
              colorText="black"
              hoverBackground="#F5F5F5"
              onClick={onCancel}
            />
          </Row>
        </Form.Item>
      </Card>
    </Form>
  );
};

export default EditbranchTypeForm;
